import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.insight)?_c('div',{staticClass:"journal-insight-bar"},[_c(VIcon,{staticClass:"journal-insight-icon",attrs:{"size":"18","color":"#1f1f1f"}},[_vm._v("fa-regular fa-sparkles")]),_c('p',{staticClass:"journal-insight-content"},[_c('span',{staticClass:"journal-insight-label"},[_vm._v(_vm._s(_vm.$t('portfolioStats.insight'))+" |")]),_c('span',{staticClass:"journal-insight-text"},[_vm._v(_vm._s(_vm.message))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }